import { PlusBackground } from '@shared/assets/icons/components';
import { Button, Flex, Input } from 'antd';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './team-filters.module.scss';

interface TeamFiltersProps {
  search: string;
  onChangeSearch: (value: string) => void;
  onButtonClick: () => void;
}

export const TeamFilters: FC<TeamFiltersProps> = ({ search, onChangeSearch, onButtonClick }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'common.filters',
  });

  return (
    <Flex gap="16px" className={styles.root}>
      <Input
        placeholder={t('search')}
        className={styles.input}
        value={search}
        size="large"
        onChange={(e) => onChangeSearch(e.target.value)}
      />
      <Button
        icon={<PlusBackground />}
        iconPosition="end"
        onClick={onButtonClick}
        type="primary"
        size="large"
        className={styles.button}
      >
        {t('inviteMore')}
      </Button>
    </Flex>
  );
};
